module.exports = __webpack_public_path__ + "img/stamp-fruit-roots-peach.f4f4caab.png";